var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column gap-4"},[(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),(_vm.hasPermission([1073741824, 2147483648]))?_c('QuotationRequest',{attrs:{"loading":_vm.loading,"quotations":_vm.quotations},on:{"refresh":_vm.getQuotations}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }